export default "__VITE_ASSET__d5df67ef__"